const FooterDisclaimer = () => {
  return (
    <p>
      Information on this site is general in nature and does not constitute
      financial, legal or tax advice. For specific details about products
      offered by the respective lending entities, please refer to the relevant
      websites via which the services are provided.
    </p>
  )
}

export default FooterDisclaimer
